import { IFirmwareState } from './i-machine';

export interface IConnectionSummary {
  /** last connect event as per session-events */
  connect_date?: string;

  /** last disconnect event as per session-events */
  disconnect_date?: string;
}

export interface IMachineUser {
  email: string;
  session: string;
  wsID: string;
  connectDate: string;
}

export interface IMachineSummary
  extends IConnectionSummary,
    Partial<IFirmwareState> {
  connected: boolean;
  calibrated: boolean;

  /** active user */
  active?: IMachineUser;

  /** users in queue */
  waiting: IMachineUser[];
}

export const DEFAULT_MACHINE_SUMMARY: IMachineSummary = {
  connected: false,
  calibrated: false,
  waiting: [],
};
